import React, { useState } from "react";
import { Modal, Form, Input, Select } from "antd";
import { notify, serverError } from "../../utils/notify";
import { adminCreateUser } from "../../network/api";
import { ROLE_OPTIONS, rankOf } from "../../constants/roles";

// currentUserRole gates which roles can be assigned (only <= your own rank).
const AddUser = ({ visible, onClose, onSubmit, currentUserRole }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  // Mirror backend: you can only assign a role <= your own rank.
  const assignableRoleOptions = ROLE_OPTIONS.filter(
    (opt) => rankOf(opt.value) <= rankOf(currentUserRole)
  );

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      setLoading(true);

      await adminCreateUser(values);

      notify.success("User created");

      form.resetFields();
      onSubmit();
      onClose();
    } catch (error) {
      if (error?.errorFields) {
        // Form validation error - antd already shows inline messages.
        setLoading(false);
        return;
      }
      console.error("Create user error:", error);
      notify.error(serverError(error, "Failed to create user"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title="Create New User"
      open={visible}
      onOk={handleOk}
      onCancel={() => {
        form.resetFields();
        onClose();
      }}
      okText="Create"
      confirmLoading={loading}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="name"
          label="Name"
          rules={[{ required: true, message: "Please enter a name" }]}
        >
          <Input placeholder="e.g. John Doe" />
        </Form.Item>

        <Form.Item
          name="email"
          label="Email"
          rules={[
            { required: true, message: "Please enter an email" },
            { type: "email", message: "Please enter a valid email" },
          ]}
        >
          <Input placeholder="e.g. john@ai360retail.com" />
        </Form.Item>

        <Form.Item
          name="password"
          label="Password"
          rules={[
            { required: true, message: "Please enter a password" },
            { min: 6, message: "Password must be at least 6 characters" },
          ]}
        >
          <Input.Password placeholder="Enter a password" />
        </Form.Item>

        <Form.Item
          name="role"
          label="Role"
          rules={[{ required: true, message: "Please select a role" }]}
        >
          <Select
            style={{ width: "100%" }}
            placeholder="Select a role"
            options={assignableRoleOptions}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default AddUser;
